import { defineStore } from 'pinia';
import { GroupedKeyValue } from '@/types/Common';
import { getSymbolsPreload } from '@/api/commonApis';

const symbolsPreloadStore = defineStore('symbolsPreloadStore', {
  state: () => ({
    symbols: {} as GroupedKeyValue,
    loaded: false as boolean,
  }),

  actions: {
    async get(group: string) {
      if (this.loaded) return this.symbols[group];
      await this.load();
      return this.symbols[group];
    },

    async load() {
      const response = await getSymbolsPreload().execute();
      this.symbols = response.data;
      this.loaded = true;
    },
  },
});
export default symbolsPreloadStore;
